import { Box, Text, useOutsideClick } from '@chakra-ui/react';
import React, { useState, useRef } from 'react'

interface StoreSelectProps {
    selectedOption: any;
    options: any[];
    onChangeDropdown: (val: any) => void;
}

const StoreSelect = ({ selectedOption, options, onChangeDropdown }: StoreSelectProps) => {
    const [isOpenSelect, setIsOpenSelect] = useState(false)
    const ref = useRef<HTMLDivElement>(null)
    
    useOutsideClick({
        ref: ref,
        handler: () => setIsOpenSelect(false),
    })

    const onSelectOption = (selectedValue:any) => {
        onChangeDropdown(selectedValue);
        setIsOpenSelect(false);
    }

    return (
        <Box className='store-select-wrapper' ref={ref}>
            <Box className='store-select-button' onClick={() => setIsOpenSelect(!isOpenSelect)}>
                <Text>{selectedOption.store_name}</Text>
                <img src="/images/ui/white-down-arrow.svg" />
            </Box>
            {isOpenSelect && (
                <Box className='s-select-option-wrapper'>
                    {options.map((storeItem: any, index: number) => (
                        <Box key={index} className={` ${selectedOption && selectedOption.store_id === storeItem.store_id ? 's-selected-option':''}  s-select-option`} onClick={() => onSelectOption(storeItem)}>
                            <Text>{storeItem.store_name}</Text>
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    )
}

export default StoreSelect
